export enum UserStatus
{
    New,
    Active,
    Inactive,
    Locked,
    Expired,
    System
}